/**
 * Why a session ended when the server says so on a 401 (the refresh then fails
 * too). Each code has its own sentence; anything else is a plain expiry.
 *
 * ⚠️⚠️ Measured in e2e 2026-09-27: an administrator closed every session
 * (`TOKEN_REVOKED`), deleted the account (`ACCOUNT_UNAVAILABLE`) or moved the
 * user to another organization (`SESSION_OUTDATED`) — and each time the user
 * read «Tu sesión ha caducado».
 */
export const SESSION_END_MESSAGE_KEYS = {
  TOKEN_REVOKED: 'auth:codes.TOKEN_REVOKED',
  ACCOUNT_UNAVAILABLE: 'auth:user.unavailable',
  SESSION_OUTDATED: 'auth:token.outdated',
} as const

export type SessionEndCode = keyof typeof SESSION_END_MESSAGE_KEYS

export function isSessionEndCode(code: unknown): code is SessionEndCode {
  return typeof code === 'string' && Object.hasOwn(SESSION_END_MESSAGE_KEYS, code)
}
